import { documentTypeSchema } from '../DocumentType/schemas';
import { createListApiSchema } from '../General/schemas';
import z from 'zod';

const statusSchema = z.enum(['accepted', 'inReview', 'pending', 'declined', 'expired', 'expiryWarning', 'superseded']);

const ownerTypeSchema = z.enum(['user', 'group', 'event']);

export const documentSchema = z
	.object({
		_id: z.string(),
		id: z.string(),
		bytes: z.number(),
		createdAt: z.coerce.date(),
		fileName: z.string(),
		link: z.string(),
		mimeType: z.string(),
		status: statusSchema,
		reviewReason: z.array(z.string()),
		flags: z.array(z.string()).optional(),
		updatedAt: z.coerce.date(),
		archived: z.boolean(),
		archivedAt: z.coerce.date().optional(),
		expiryDate: z.coerce.date().optional(),
		metadata: z.any(),
		ownerId: z.string(),
		ownerType: ownerTypeSchema,
		description: z.string().optional(),
		externalUrl: z.string().optional(),
		documentId: z.string().optional(),
		validity: z.string().optional(),
		type: z.string(),
		key: z.string().optional(),
		iv: z.string().optional(),
		salt: z.string().optional(),
		hasBeenReviewed: z.boolean(),
		reviewAcknowledged: z.boolean().optional(),
		statusReason: z.string().optional(),
		documentType: z.lazy(() => documentTypeSchema).optional(),
		logs: z.array(z.any()).optional()
	})
	.describe('Document');

export const documentListSchema = createListApiSchema(documentSchema);
